var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1525 10.8995L12.1369 19.9151C10.0866 21.9653 6.76253 21.9653 4.71228 19.9151C2.66203 17.8648 2.66203 14.5407 4.71228 12.4905L13.7279 3.47486C15.0947 2.10803 17.3108 2.10803 18.6776 3.47486C20.0445 4.8417 20.0445 7.05778 18.6776 8.42461L10.0156 17.0867C9.33216 17.7701 8.22412 17.7701 7.54071 17.0867C6.85729 16.4033 6.85729 15.2952 7.54071 14.6118L15.1421 7.0104",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.9aa1e2fb1318878d16ca35b8ceb574d3.svg";
export { ForwardRef as ReactComponent };